import React, { useState, useEffect, useContext } from "react";
import SubsidiaryAppSurveyReadOnlyRow from "./SubsidiaryAppSurveyReadOnlyRow";
import SubsidiaryAppSurveyTableRow from "./SubsidiaryAppSurveyTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";


function SubsidiaryAppSurveyTable({ key, setSubsidiaryAppSurvey, loginId, companyId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isAppSurveyNameLoading, setIsAppSurveyNameLoading] = useState(false);
	const [appSurveyNames, setAppSurveyNames] = useState([]);
	const [isSubsidiaryAppSurveyLoading, setIsSubsidiaryAppSurveyLoading] = useState(false);
	const [isUserSubsidiaryLoading, setIsUserSubsidiaryLoading] = useState(false);
	const [subsidiaryAppSurveys, setSubsidiaryAppSurveys] = useState([]);
	const [userSubsidiaries, setUserSubsidiaries] = useState([]);
	const [count, setCount] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		subsidiaryCompanyId: 0,
		appSurveyKey: 0,
		canRead: false,
		canWrite: false,
		canReview: false,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		fetchUserSubsidiaries();
		fetchAppSurveyNames();
		fetchSubsidiaryAppSurveys();
	}, []);

	const handleClose = (event) => {
		setSubsidiaryAppSurvey(false);
	};


	function fetchUserSubsidiaries() {
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}

		setIsUserSubsidiaryLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: true,
				companyId: initialValues.companyId,
				loginId: initialValues.loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetSubsidiariesForUser", "/Service/UserService/GetSubsidiariesForUser", requestOptions, retrieveUserSubsidiarySuccess, retrieveUserSubsidiaryFail);
		} catch (error) {
			setIsUserSubsidiaryLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveUserSubsidiaryFail(redirect) {
		setIsUserSubsidiaryLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.userGetSubsidiaryFailed"));
	}

	function retrieveUserSubsidiarySuccess(responseData) {
		let getSubsidiariesForUserResponse;
		if (responseData) {
			getSubsidiariesForUserResponse = responseData.getSubsidiariesForUserResponse;
			if (getSubsidiariesForUserResponse && getSubsidiariesForUserResponse.errorCode === "0") {
				setUserSubsidiaries(getSubsidiariesForUserResponse.subsidiaryList.slice())
			} else if (getSubsidiariesForUserResponse && getSubsidiariesForUserResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getSubsidiariesForUserResponse) {
				setError(t("error.error") + " " + getSubsidiariesForUserResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserSubsidiaryLoading(false);
	}

	function fetchAppSurveyNames() {
		setError("");
		setIsAppSurveyNameLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false
			}),
		};
		try {
			FetchUtil.fetchAPI("GetAppSurveyNames", "/Service/StaticHelper/GetAppSurveyNames", requestOptions, retrieveAppSurveyNameSuccess, retrieveAppSurveyNameFail);
		} catch (error) {
			setIsAppSurveyNameLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveAppSurveyNameFail(redirect) {
		setIsAppSurveyNameLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.getAppSurveyFailed"));
	}

	function retrieveAppSurveyNameSuccess(responseData) {
		let getAppSurveyNameResponse;
		if (responseData) {
			getAppSurveyNameResponse = responseData.getAppSurveyNameResponse;
			if (getAppSurveyNameResponse && getAppSurveyNameResponse.errorCode === "0") {
				setAppSurveyNames(getAppSurveyNameResponse.appSurveyList.slice())
			} else if (getAppSurveyNameResponse && getAppSurveyNameResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getAppSurveyNameResponse) {
				setError(t("error.error") + " " + getAppSurveyNameResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsAppSurveyNameLoading(false);
	}

	function fetchSubsidiaryAppSurveys() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}
		resetCounter();
		setIsSubsidiaryAppSurveyLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true, companyId: initialValues.companyId,
				loginId: initialValues.loginId, userCompanyId: userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserSubsidiaryAppSurvey", "/Service/PartnerSubsService/GetUserSubsidiaryAppSurvey", requestOptions, retrieveSubsidiaryAppSurveySuccess, retrieveSubsidiaryAppSurveyFail);
		} catch (error) {
			setIsSubsidiaryAppSurveyLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveSubsidiaryAppSurveyFail(redirect) {
		setIsSubsidiaryAppSurveyLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.subsidiaryGetAppSurveyFailed"));
	}

	function retrieveSubsidiaryAppSurveySuccess(responseData) {
		let fetchUserSubsAppSurveysResponse;
		if (responseData) {
			fetchUserSubsAppSurveysResponse = responseData.fetchUserSubsAppSurveysResponse;
			if (fetchUserSubsAppSurveysResponse && fetchUserSubsAppSurveysResponse.errorCode === "0") {
				setSubsidiaryAppSurveys(fetchUserSubsAppSurveysResponse.appSurveyList.slice())
			} else if (fetchUserSubsAppSurveysResponse && fetchUserSubsAppSurveysResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserSubsAppSurveysResponse) {
				setError(t("error.error") + " " + fetchUserSubsAppSurveysResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsSubsidiaryAppSurveyLoading(false);
	}

	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};

	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleDeleteClick = (event, userSubsidiaryItem, completeCallback) => {
		event.preventDefault();
		deleteSubsidiaryAppSurvey(userSubsidiaryItem, completeCallback);
	};
	const deleteSubsidiaryAppSurvey = (userSubsidiaryItem, completeCallback) => {
		let action = 3;
		if (userSubsidiaryItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			loginId: formValues.loginId,
			appSurveyKey: userSubsidiaryItem.appSurveyKey,
			subsidiaryCompanyId: userSubsidiaryItem.subsidiaryCompanyId,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserSubsidiaryAppSurvey", "/Service/PartnerSubsService/DeleteUserSubsidiaryAppSurvey", requestOptions, deleteSubsidiaryAppSurveySuccess, deleteSubsidiaryAppSurveyFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteSubsidiaryAppSurveyFail(redirect, completeCallback) {
		setError(t("error.userAppSurveyEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteSubsidiaryAppSurveySuccess(responseData, completeCallback) {
		let deleteUserSubsAppSurveyResponse;
		if (responseData) {
			deleteUserSubsAppSurveyResponse = responseData.deleteUserSubsAppSurveyResponse;
			if (deleteUserSubsAppSurveyResponse) {
				if (deleteUserSubsAppSurveyResponse.errorCode === "0") {
					resetRowTable();
					refreshSubsidiaryAppSurvey();
				} else {
					setError(t("error.error") + " " +
						deleteUserSubsAppSurveyResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (subsidiaryAppSurveys.length > 0) {
				subsidiaryAppSurveys.map((subsidiaryAppSurveyItem, index) => {
					if (subsidiaryAppSurveyItem.appSurveyKey === setValues.appSurveyKey && subsidiaryAppSurveyItem.subsidiaryCompanyId == setValues.subsidiaryCompanyId) {
						setError(t("error.userAppSurveyDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveSubsidiaryAppSurvey(action, setValues, completeCallback);
			} else {
				if (completeCallback) {
					completeCallback();
				}
			}
		} else if (action === 2) {
			if (subsidiaryAppSurveys.length > 0) {
				subsidiaryAppSurveys.map((subsidiaryAppSurveyItem, index) => {
					if (subsidiaryAppSurveyItem.appSurveyKey === setValues.appSurveyKey && subsidiaryAppSurveyItem.subsidiaryCompanyId == setValues.subsidiaryCompanyId) {
						found = true;
					}
				})
			}
			if (found) {
				saveSubsidiaryAppSurvey(action, setValues, completeCallback);
			} else {
				if (completeCallback) {
					completeCallback();
				}
			}
		} else if (completeCallback) {
			completeCallback();
		}
	};
	const saveSubsidiaryAppSurvey = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			companyId: formValues.companyId,
			subsidiaryCompanyId: setValues.subsidiaryCompanyId,
			appSurveyKey: setValues.appSurveyKey,
			canRead: setValues.canRead,
			canWrite: setValues.canWrite,
			canReview: setValues.canReview,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserSubsidiaryAppSurvey", "/Service/PartnerSubsService/AddUpdateUserSubsidiaryAppSurvey", requestOptions, saveSubsidiaryAppSurveySuccess, saveSubsidiaryAppSurveyFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveSubsidiaryAppSurveyFail(redirect, completeCallback) {
		setError(t("error.userAppSurveyEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveSubsidiaryAppSurveySuccess(responseData, completeCallback) {
		let addUpdateUserSubsAppSurveyResponse;
		if (responseData) {
			addUpdateUserSubsAppSurveyResponse = responseData.addUpdateUserSubsAppSurveyResponse;
			if (addUpdateUserSubsAppSurveyResponse) {
				if (addUpdateUserSubsAppSurveyResponse.errorCode === "0") {
					resetRowTable();
					refreshSubsidiaryAppSurvey();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserSubsAppSurveyResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshSubsidiaryAppSurvey() {
		fetchSubsidiaryAppSurveys();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isAppSurveyNameLoading || isSubsidiaryAppSurveyLoading || isUserSubsidiaryLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("page.subsidiary")}</th>
										<th className="list-th">{t("page.app.name")}</th>
										<th className="list-th">{t("page.survey.name")}</th>
										<th className="list-th">{t("page.read")}</th>
										<th className="list-th">{t("page.write")}</th>
										<th className="list-th">{t("page.review")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<SubsidiaryAppSurveyTableRow
											index={count}
											appSurveyNames={appSurveyNames}
											userSubsidiaries={userSubsidiaries}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((subsidiaryAppSurveys.length % 2) > 0) ? true : false} />
									}
									{(subsidiaryAppSurveys.length > 0) ? (
										subsidiaryAppSurveys.map((subsidiaryAppSurveyItem, index) => (
											<SubsidiaryAppSurveyReadOnlyRow
												index={count}
												t={t}
												subsidiaryAppSurveyItem={subsidiaryAppSurveyItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												setError={setError}
												handleSubmit={handleSubmit}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<SubsidiaryAppSurveyTableRow
											index={count}
											appSurveyNames={appSurveyNames}
											userSubsidiaries={userSubsidiaries}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((subsidiaryAppSurveys.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(subsidiaryAppSurveys.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("page.subsidiary")}</th>
										<th className="list-th">{t("page.app.name")}</th>
										<th className="list-th">{t("page.survey.name")}</th>
										<th className="list-th">{t("page.read")}</th>
										<th className="list-th">{t("page.write")}</th>
										<th className="list-th">{t("page.review")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-sub-appsurvey-close"
									id="edit-sub-appsurvey-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default SubsidiaryAppSurveyTable;